import React from 'react';
import services from '../data/services';
import Grouped from '../Components/Grouped';


const Service = ({item, year, venue}) => (<div className='service'>
    <span>{item}. </span>
    <span>{venue} </span>
    <span>{year}</span>
</div>)

const Services = ({}) => (
    <div className='services page'>
        <Grouped data={services} by='role' Component={Service} />
    </div>
);


export default Services;